import { render, staticRenderFns } from "./gridStoricoDettaglio.vue?vue&type=template&id=6295e950&"
import script from "./gridStoricoDettaglio.vue.ts?vue&type=script&lang=ts&"
export * from "./gridStoricoDettaglio.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports